import { render, staticRenderFns } from "./ShareFilePage.vue?vue&type=template&id=1e5b0eab"
import script from "./ShareFilePage.vue?vue&type=script&lang=js"
export * from "./ShareFilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports